import { EntityReference, Money, OptionsetItem, GUID, BaseEntity } from './base/base';

export class GeneratedRefreshtoken extends BaseEntity {

	_clientid?: string;

	_expires?: Date;

	_issued?: Date;

	_name: string;

	_protectedticket?: string;

	_refreshtokenId: GUID;

	_tokenhash?: string;

	_createdOnBehalfBy?: EntityReference;

	_importSequenceNumber?: Number;

	_modifiedOnBehalfBy?: EntityReference;

	_overriddenCreatedOn?: Date;

	_ownerId: EntityReference;

	_owningBusinessUnit?: EntityReference;

	_owningTeam?: EntityReference;

	_owningUser?: EntityReference;

	_statecode: OptionsetItem;

	_statuscode?: OptionsetItem;

	_timeZoneRuleVersionNumber?: Number;

	_uTCConversionTimeZoneCode?: Number;

	_versionNumber?: Number;
	constructor() {
		super('refreshtokenId');
	}

	get clientid(): string
	{
		return this._clientid;
	};
	set clientid(val: string)
	{
		this._clientid = val;
		this._attributeValues['clientid'] = this._clientid;
	};

	get expires(): Date
	{
		return this._expires;
	};
	set expires(val: Date)
	{
		this._expires = val;
		this._attributeValues['expires'] = this._expires;
	};

	get issued(): Date
	{
		return this._issued;
	};
	set issued(val: Date)
	{
		this._issued = val;
		this._attributeValues['issued'] = this._issued;
	};

	get name(): string
	{
		return this._name;
	};
	set name(val: string)
	{
		this._name = val;
		this._attributeValues['name'] = this._name;
	};

	get protectedticket(): string
	{
		return this._protectedticket;
	};
	set protectedticket(val: string)
	{
		this._protectedticket = val;
		this._attributeValues['protectedticket'] = this._protectedticket;
	};

	get refreshtokenId(): GUID
	{
		return this._refreshtokenId;
	};
	set refreshtokenId(val: GUID)
	{
		this._id = val;
		this._refreshtokenId = val;
		this._attributeValues['refreshtokenId'] = this._refreshtokenId;
	};

	get tokenhash(): string
	{
		return this._tokenhash;
	};
	set tokenhash(val: string)
	{
		this._tokenhash = val;
		this._attributeValues['tokenhash'] = this._tokenhash;
	};

	get createdOnBehalfBy(): EntityReference
	{
		return this._createdOnBehalfBy;
	};
	set createdOnBehalfBy(val: EntityReference)
	{
		this._createdOnBehalfBy = val;
		this._attributeValues['createdOnBehalfBy'] = this._createdOnBehalfBy;
	};

	get importSequenceNumber(): Number
	{
		return this._importSequenceNumber;
	};
	set importSequenceNumber(val: Number)
	{
		this._importSequenceNumber = val;
		this._attributeValues['importSequenceNumber'] = this._importSequenceNumber;
	};

	get modifiedOnBehalfBy(): EntityReference
	{
		return this._modifiedOnBehalfBy;
	};
	set modifiedOnBehalfBy(val: EntityReference)
	{
		this._modifiedOnBehalfBy = val;
		this._attributeValues['modifiedOnBehalfBy'] = this._modifiedOnBehalfBy;
	};

	get overriddenCreatedOn(): Date
	{
		return this._overriddenCreatedOn;
	};
	set overriddenCreatedOn(val: Date)
	{
		this._overriddenCreatedOn = val;
		this._attributeValues['overriddenCreatedOn'] = this._overriddenCreatedOn;
	};

	get ownerId(): EntityReference
	{
		return this._ownerId;
	};
	set ownerId(val: EntityReference)
	{
		this._ownerId = val;
		this._attributeValues['ownerId'] = this._ownerId;
	};

	get owningBusinessUnit(): EntityReference
	{
		return this._owningBusinessUnit;
	};
	set owningBusinessUnit(val: EntityReference)
	{
		this._owningBusinessUnit = val;
		this._attributeValues['owningBusinessUnit'] = this._owningBusinessUnit;
	};

	get owningTeam(): EntityReference
	{
		return this._owningTeam;
	};
	set owningTeam(val: EntityReference)
	{
		this._owningTeam = val;
		this._attributeValues['owningTeam'] = this._owningTeam;
	};

	get owningUser(): EntityReference
	{
		return this._owningUser;
	};
	set owningUser(val: EntityReference)
	{
		this._owningUser = val;
		this._attributeValues['owningUser'] = this._owningUser;
	};

	get statecode(): OptionsetItem
	{
		return this._statecode;
	};
	set statecode(val: OptionsetItem)
	{
		this._statecode = val;
		this._attributeValues['statecode'] = this._statecode;
	};

	get statuscode(): OptionsetItem
	{
		return this._statuscode;
	};
	set statuscode(val: OptionsetItem)
	{
		this._statuscode = val;
		this._attributeValues['statuscode'] = this._statuscode;
	};

	get timeZoneRuleVersionNumber(): Number
	{
		return this._timeZoneRuleVersionNumber;
	};
	set timeZoneRuleVersionNumber(val: Number)
	{
		this._timeZoneRuleVersionNumber = val;
		this._attributeValues['timeZoneRuleVersionNumber'] = this._timeZoneRuleVersionNumber;
	};

	get uTCConversionTimeZoneCode(): Number
	{
		return this._uTCConversionTimeZoneCode;
	};
	set uTCConversionTimeZoneCode(val: Number)
	{
		this._uTCConversionTimeZoneCode = val;
		this._attributeValues['uTCConversionTimeZoneCode'] = this._uTCConversionTimeZoneCode;
	};

	get versionNumber(): Number
	{
		return this._versionNumber;
	};
	set versionNumber(val: Number)
	{
		this._versionNumber = val;
		this._attributeValues['versionNumber'] = this._versionNumber;
	};
}



// WEBPACK FOOTER //
// ./src/app/schemas/codegen/GeneratedRefreshtoken.ts